import { Link } from "react-router-dom";
import { SealCheck } from "@phosphor-icons/react";

export default function ArtistCard({ artist, index = 0 }) {
  // Support both backend shape (handle/photo/primary_discipline/city) and legacy mock shape (slug/avatar/role).
  const handle = artist.handle || artist.slug || "unknown";
  const photo = artist.photo || artist.avatar;
  const role =
    artist.role ||
    (artist.primary_discipline
      ? artist.primary_discipline.replace(/-/g, " ").toUpperCase()
      : "");
  const city = artist.city || "";
  return (
    <Link
      to={`/artista/${handle}`}
      data-testid={`artist-card-${handle}`}
      className="group block border border-[#27272A] hover:border-[#FF3E00] bg-[#0a0a0a] transition-colors"
    >
      <div className="relative aspect-square overflow-hidden bg-[#121212]">
        {photo ? (
          <img
            src={photo}
            alt={artist.name}
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
          />
        ) : null}
        <div className="absolute top-0 left-0 right-0 flex items-center justify-between px-3 py-2 bg-gradient-to-b from-black/70 to-transparent">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#F4F4F5]">
            {String(index + 1).padStart(3, "0")}
          </span>
          {artist.verified ? (
            <span className="bg-[#FF3E00] text-white p-1">
              <SealCheck size={12} weight="fill" />
            </span>
          ) : null}
        </div>
      </div>
      <div className="p-4 border-t border-[#27272A]">
        <div className="flex items-center gap-1.5">
          <h3 className="font-display font-bold text-lg tracking-tight truncate">
            {artist.name}
          </h3>
        </div>
        <p className="font-mono text-[10px] text-[#A1A1AA] uppercase tracking-[0.15em] mt-1 truncate">
          {role}
        </p>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-[#27272A] font-mono text-[10px] tracking-wider">
          <span className="text-[#A1A1AA]">{city.toUpperCase()}</span>
          <span className="text-[#FF3E00]">
            {(artist.followers || 0) >= 1000
              ? ((artist.followers || 0) / 1000).toFixed(1) + "K"
              : artist.followers || 0}{" "}
            FLW
          </span>
        </div>
      </div>
    </Link>
  );
}
